import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

interface Props {
  achievementId?: number;
  updateAchievements: () => Promise<void>;
}

const CalendarEventAchievementsRemove = ({
  achievementId,
  updateAchievements
}: Props) => {
  const {
    messages,
    pageState: { calendarEvent }
  } = useReduxState();

  if (!calendarEvent) return null;

  const handleConfirm = async () => {
    await api.delete(
      `/admin/calendar-events/${calendarEvent.id}/achievements${
        achievementId ? `/${achievementId}` : ''
      }`
    );
    await updateAchievements();
    return true;
  };

  const buttonProps = achievementId
    ? {
        buttonText: messages.commonRemoveAchievement,
        confirmTitle: messages.commonRemoveAchievement,
        confirmText: messages.eventCalendarAchievementRemoveMessage,
        successMessage: messages.commonRemoveAchievementSuccess
      }
    : {
        buttonText: messages.eventCalendarAchievementRemoveAll,
        confirmTitle: messages.eventCalendarAchievementRemoveAll,
        confirmText: messages.eventCalendarAchievementRemoveMessageAll,
        successMessage: messages.eventCalendarAchievementRemoveSuccessAll
      };

  return (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonIcon="trash-alt"
      category="danger"
      onConfirm={handleConfirm}
      {...buttonProps}
    />
  );
};

export default CalendarEventAchievementsRemove;
